import React from 'react';
import './WhyUsPage.css';

import { PageTitle } from '../../../components';
import { faqsContent } from '../../../constants';
import { Counter, WhyUs,  Services, Clients, Industries, Process, CaseSection, Testimonials, FAQs, Features } from '../../../sections';



const WhyUsPage = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'Why Choose Us'} page={'Why Choose Us'} />

      <section className='whyUs-page'>

        <Features /> {/* Features section */}
        <WhyUs /> {/* Why Choose Us section */}
        <Services /> {/* Services section */}
        <Counter /> {/* Stats section */}
        <Process /> {/* Process slider */}
        <Industries /> {/* Industries Served */}
        <FAQs faqsContent={faqsContent} /> {/* FAQs Section */}
        <Testimonials /> {/* Testimonials slider */}
        <CaseSection /> {/* Case Studies Section */}
        <Clients /> {/* Clients section */}

      </section>

    </>
  );
}

export default WhyUsPage;